const DATABASE_NAME = "sizesoftx-support-manual-captures";
const DATABASE_VERSION = 1;
const STORE_NAME = "drafts";

let databasePromise;

const openDatabase = () => {
  if (!globalThis.indexedDB) {
    return Promise.reject(new Error("Este navegador no permite guardar capturas locales."));
  }
  if (!databasePromise) {
    databasePromise = new Promise((resolve, reject) => {
      const request = indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
      request.onupgradeneeded = () => {
        const database = request.result;
        if (!database.objectStoreNames.contains(STORE_NAME)) {
          database.createObjectStore(STORE_NAME, { keyPath: "draft_id" });
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error || new Error("No se pudo abrir el almacenamiento de capturas."));
      request.onblocked = () => reject(new Error("Cierra otras pestañas de Support antes de actualizar las capturas locales."));
    });
  }
  return databasePromise;
};

const runTransaction = async (mode, action) => {
  const database = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, mode);
    const store = transaction.objectStore(STORE_NAME);
    let result;
    try {
      result = action(store);
    } catch (error) {
      reject(error);
      return;
    }
    transaction.oncomplete = () => resolve(result?.result);
    transaction.onerror = () => reject(transaction.error || new Error("Falló el almacenamiento local de capturas."));
    transaction.onabort = () => reject(transaction.error || new Error("Se canceló el almacenamiento local de capturas."));
  });
};

export const listManualDrafts = async () => {
  const drafts = await runTransaction("readonly", store => store.getAll());
  return (drafts || []).sort((left, right) => right.updated_at.localeCompare(left.updated_at));
};

export const saveManualDraft = draft => runTransaction("readwrite", store => store.put(draft));

export const deleteManualDraft = draftId => runTransaction("readwrite", store => store.delete(draftId));